import { EntitlementAvatarProps } from './avatars/EntitlementAvatar'

export { EntitlementAvatar } from './avatars/EntitlementAvatar'

export type { EntitlementAvatarProps }
